"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _vanillaJsoneditor = require("vanilla-jsoneditor");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var Editor = function Editor(props) {
  var editorRef = (0, _react.useRef)(null);
  var container = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    editorRef.current = new _vanillaJsoneditor.JSONEditor({
      target: container.current,
      props: {
        mode: _vanillaJsoneditor.Mode.text
      }
    });
    return function () {
      var _editorRef$current;
      (_editorRef$current = editorRef.current) === null || _editorRef$current === void 0 || _editorRef$current.destroy();
    };
  }, []);
  (0, _react.useEffect)(function () {
    var _editorRef$current2;
    (_editorRef$current2 = editorRef.current) === null || _editorRef$current2 === void 0 || _editorRef$current2.updateProps(props);
  }, [props]);
  return /*#__PURE__*/_react.default.createElement("div", {
    ref: container,
    className: "vanilla-jsoneditor-react"
  });
};
var _default = exports.default = Editor;